import { createSelector } from 'reselect';
import { selector } from './reducer';

const smallScreenSize = 800;

export default {
  dimensions: createSelector(selector, (state) => state),
  landscape: createSelector(selector, (state) => state.width > state.height),
  portrait: createSelector(selector, (state) => state.width <= state.height),
  small: createSelector(selector, (state) => state.width <= smallScreenSize),
  width: createSelector(selector, (state) => state.width),
  height: createSelector(selector, (state) => state.height),  
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/window/selectors.tsx